import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {
  Jumbotron,
  Container
} from 'reactstrap';

export default class About extends Component {
  render() {
    return (
      <div>
        <Container className="text-center">
          <br/> <br/>
            <h1 id="aboutHead">About Tortilleria Rio...</h1>
            <h4>Tortilleria Rio serves only the highest quality ingredients, with no added GMO. </h4>
            <div>
              <br/><br/>
              <p id="aboutP">Dear Customer,<br/><em>Tortilleria Rio</em> is a family owned and operated, Authentic Mexican restaurant and tortilla factory.
                What once was just a dream for Maria and Arturo Campos has finally become a reality. They have been
                investing in making this family dream come true since 2010 when they poured everything into buying the
                property that is now Tortilleria Rio. They have been planning on doing this for 20+ years. Maria and 
                Arturo have always been gifted in creating the most Authentic Home cooked meals for Family and Friends
                since the 1990s. What they cooked for the love of seeing their family & friends happy and full, now  
                brings great joy to all of Waco. This passion has become a family business. Finally,
                after 7 long years of working to make this business venture a reality, January 9th of 2017 marks the
                day that the Campos family opened for business at Tortilleria Rio. A true Family owned and
                operated, local, small business. Here at Tortilleria Rio we make fresh, all natural, non-GMO corn
                tortillas every day, and we can provide any and all of your tortilla needs for any event, big or small. We 
                can make your order fresh and ready to pick up at your convenience. Our hand rolled flour tortillas for our 
                burritos are made from scratch just like everything else that we offer. Every day we serve the best Gorditas 
                and Burritos, always fresh & made on the spot with the Authentic taste of a home cooked meal that Tortilleria 
                Rio is known for. We have fresh Taco shells, Tostadas, and chips along with a variety of sauces and salsas to 
                accompany your food, event, or party. Saturday and Sunday we offer tasty Menudo, the best Carnitas in town, 
                and our authentic Barbabcoa. We have quesos Mexicanos (Mexican Cheeses), Mexican Soft drinks, and Mexican 
                candy. We can make special orders at your request. From Corn Tortillas to the Food going in them. None of 
                this would be possible without the support of our family and friends who have always believed in us and our cooking. 
                From Grandma's humble kitchen in Zacatecas, Mexico brought to you here at 1220 Dutton Ave Waco TX. We want to 
                welcome you with open arms at Tortilleria Rio.<br/>
                Sincerely,<br/>
                Campos Family</p>
            </div>
        </Container>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/About.js